import Response from "../../Data/Domain/Response";
import StationData from "../Domain/StationData";
import { getStationData } from "./StationData.service";

export async function getStationDataRepository(params) {
  const data = await getStationData(params);
  return new Response(data, StationData).getMultiple();
}
